// @core/api/endpoints/attachment/abort_multipart_upload.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AbortMultipartUploadRequest,
} from '../../../types/attachment';

const BASE_PATH = '/attachment';

/**
 * Abort multipart upload
 * Cancels an in-progress multipart upload and deletes any uploaded parts. Use when an upload fails or is no longer needed to clean up storage resources.
 */
export async function AbortMultipartUpload(
  data: AbortMultipartUploadRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/attachments/multipart/abort`;
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
